import { combineReducers } from "redux";
import { API } from "../../../../../const";
import _ from "lodash";
import { unAuthorized } from "../../../../auth/Auth.ducks";
import { Service } from "../../../../service/service";

export const GET_NOTES_PENDING = "GET_NOTES_PENDING";
export const GET_NOTES_REJECTED = "GET_NOTES_REJECTED";
export const GET_NOTES_FULFILLED = "GET_NOTES_FULFILLED";

export const POST_NOTE_PENDING = "POST_NOTE_PENDING";
export const POST_NOTE_REJECTED = "POST_NOTE_REJECTED";
export const POST_NOTE_FULFILLED = "POST_NOTE_FULFILLED";

export const PUT_NOTE_PENDING = "PUT_NOTE_PENDING";
export const PUT_NOTE_REJECTED = "PUT_NOTE_REJECTED";
export const PUT_NOTE_FULFILLED = "PUT_NOTE_FULFILLED";

export const DELETE_NOTE_PENDING = "DELETE_NOTE_PENDING";
export const DELETE_NOTE_REJECTED = "DELETE_NOTE_REJECTED";
export const DELETE_NOTE_FULFILLED = "DELETE_NOTE_FULFILLED";

const loading = (state = false, { type }) => {
  switch (type) {
    case GET_NOTES_PENDING:
      return true;
    case GET_NOTES_REJECTED:
    case GET_NOTES_FULFILLED:
      return false;
    default:
      return state;
  }
};

const error = (state = null, { type, payload }) => {
  switch (type) {
    case GET_NOTES_PENDING:
    case GET_NOTES_FULFILLED:
      return null;
    case GET_NOTES_REJECTED:
      return payload;
    default:
      return state;
  }
};

const data = (state = [], { type, payload }) => {
  switch (type) {
    case GET_NOTES_FULFILLED:
      return _.isEmpty(payload.data)
        ? []
        : payload.data.notesEnfant;
    default:
      return state;
  }
};

export default combineReducers({ loading, error, data });

export const getNotes = (tok, idEnfant) => {
  return (dispatch) => {
    dispatch({ type: GET_NOTES_PENDING });
    const response = Service.get(
      `${API}api/enfant/creche/enfants/${idEnfant}/notes`,
      { headers: { Authorization: `Bearer ${tok}` } }
    );
    response.then((res) => {
      dispatch({ type: GET_NOTES_FULFILLED, payload: res });
    });
    response.catch((err) => {
      let message = !_.isEmpty(err.response)
        ? err.response.data.message
        : null;
      dispatch({ type: "OPEN_SNACKBAR_ERROR", payload: message });
      dispatch({ type: GET_NOTES_REJECTED, payload: err });
      if (err && err.response && err.response.status === 401) {
        dispatch(unAuthorized());
      }
    });
  };
};

export const postNote = (tok, idEnfant, data) => {
  return (dispatch) => {
    dispatch({ type: POST_NOTE_PENDING });
    const response = Service.post(
      `${API}api/enfant/creche/enfants/${idEnfant}/notes`,
      data,
      { headers: { Authorization: `Bearer ${tok}` } }
    );
    response.then((res) => {
      dispatch({ type: POST_NOTE_FULFILLED, payload: res });
      dispatch(getNotes(tok, idEnfant));
    });
    response.catch((err) => {
      let message = !_.isEmpty(err.response)
        ? err.response.data.message
        : null;
      dispatch({ type: "OPEN_SNACKBAR_ERROR", payload: message });
      dispatch({ type: POST_NOTE_REJECTED, payload: err });
      if (err && err.response && err.response.status === 401) {
        dispatch(unAuthorized());
      }
    });
  };
};

export const putNote = (tok, idNote, data, idEnfant) => {
  return (dispatch) => {
    dispatch({ type: PUT_NOTE_PENDING });
    const response = Service.put(
      `${API}api/enfant/creche/notes/${idNote}`,
      data,
      { headers: { Authorization: `Bearer ${tok}` } }
    );
    response.then((res) => {
      dispatch({ type: PUT_NOTE_FULFILLED, payload: res });
      dispatch(getNotes(tok, idEnfant));
    });
    response.catch((err) => {
      let message = !_.isEmpty(err.response)
        ? err.response.data.message
        : null;
      dispatch({ type: "OPEN_SNACKBAR_ERROR", payload: message });
      dispatch({ type: PUT_NOTE_REJECTED, payload: err });
      if (err && err.response && err.response.status === 401) {
        dispatch(unAuthorized());
      }
    });
  };
};

export const deleteNote = (tok, idNote, idEnfant) => {
  return (dispatch) => {
    dispatch({ type: DELETE_NOTE_PENDING });
    const response = Service.deleteOne(
      `${API}api/enfant/creche/notes/${idNote}`,
      { headers: { Authorization: `Bearer ${tok}` } }
    );
    response.then((res) => {
      dispatch({ type: DELETE_NOTE_FULFILLED, payload: res });
      dispatch(getNotes(tok, idEnfant));
    });
    response.catch((err) => {
      let message = !_.isEmpty(err.response)
        ? err.response.data.message
        : null;
      dispatch({ type: "OPEN_SNACKBAR_ERROR", payload: message });
      dispatch({ type: DELETE_NOTE_REJECTED, payload: err });
      if (err && err.response && err.response.status === 401) {
        dispatch(unAuthorized());
      }
    });
  };
};
